// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrump_wrapper__cCeZt"};